import React from 'react';
import { EnvelopeAtFill, PhoneFill, MapFill, Whatsapp } from 'react-bootstrap-icons';
import logo from '../../utils/rmc.png';
import { useTiendaConfig } from '../../hooks/useTiendaConfig';
import { useCompanyInfo } from '../../hooks/useCompanyInfo';
import getIcon from '../../utils/getIcon';
import { Button } from 'react-bootstrap';
import InstallShortcutButton from './componentes/InstallShortcutButton';

function FooterPublic() {
  const { socialLinks, whatsappLink } = useTiendaConfig();
  const { companyData } = useCompanyInfo();

  const getCurrentYear = () => {
    return new Date().getFullYear();
  };

  const getWhatsappUrl = () => {
    // Verifica si whatsappLink existe y tiene una URL válida
    if (whatsappLink && typeof whatsappLink.url === 'string' && whatsappLink.url.trim() !== '') {
      return whatsappLink.url;
    }
    // Si no se encuentra un enlace válido, devuelve un fallback
    return '#'; // O un valor predeterminado que prefieras
  };

  return (
    <>
      <footer className="bg-black text-white py-4">
        {/* Contenido central */}
        <div className="container text-center">
          <div className="mb-4">
            <img
              src={logo} // Reemplaza por la ruta del logo
              alt="Rey Midas Logo"
              style={{ maxWidth: '200px' }}
              loading='lazy'
            />
          </div>
          <div className="d-flex align-items-center justify-content-center gap-2 mb-4">
            <InstallShortcutButton />
          </div>
          <div className="d-flex align-items-center justify-content-center gap-2 mb-4">
            <Button
              variant="danger"
              className="d-flex align-items-center position-relative"
              aria-label="Unirse al grupo mayorista en WhatsApp"
              title="Unirse al grupo mayorista en WhatsApp"
              as="a" // Convierte el botón en un enlace
              href={getWhatsappUrl()} // Función que asegura que siempre se pase una cadena válida
              target="_blank" // Abre el enlace en una nueva pestaña
              rel="noopener noreferrer"
            >
              <Whatsapp size={20} className='me-2' />
              <span className='ms-0 ms-md-2'>Grupo Difusión</span>
            </Button>
          </div>
          <div>
            <p className="mb-2">
              <MapFill className='text-danger me-2' size={18} /> {companyData.direccion}
              <br />
              {companyData.ciudad} - {companyData.departamento}
            </p>
            <p className="mb-2">
              <PhoneFill className='text-danger me-2' size={18} /> {companyData.telefono}
            </p>
            <p>
              <EnvelopeAtFill className='text-danger me-2' size={18} /><a href="mailto:elmao1989@hotmail.com" className="text-white" target="_blank" rel="noreferrer">{companyData.email}</a>
            </p>
          </div>
        </div>

        <hr className="bg-light my-4" />

        {/* Flexbox para el Copyright y Redes Sociales */}
        <div className="container-fluid">
          <div className="row align-items-center">
            <div className="col-12 col-md-6 text-center text-md-start">
              <p className="small mb-0">
                &copy; {getCurrentYear()} Rey Midas Caps, All Rights Reserved <br />
                Designed by <a href="https://tubisnez.netlify.app/" target="_blank" rel="noreferrer" className="fw-bold text-danger text-decoration-none">TuBisnez</a>
              </p>
            </div>

            {/* Redes sociales a la derecha */}
            <div className="col-12 col-md-6 text-center text-md-end mt-3 mt-md-0">
              {socialLinks.map((link, index) => (
                <a
                  key={index}
                  href={link.url}
                  rel='noreferrer noopener'
                  title={link.title}
                >
                  <Button variant="link" className="text-white">
                    {getIcon(link.url)}
                  </Button>
                </a>
              ))}
            </div>
          </div>
        </div>
      </footer>
    </>
  );
}

export default FooterPublic;
